import { Children, cloneElement, useState, useRef, useEffect } from 'react';

/**
 * Provides own coords, width and height to its children.
 * Data will be passed to each children element through the "container" prop.
 */
const ResponsiveContainer = ({ children, ...props }) => {
  const containerRef = useRef(null);
  const [rect, setRect] = useState(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const resizeObserver = new ResizeObserver(([entry]) => {
      setRect(entry.contentRect);
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.unobserve(container);
    };
  }, [containerRef]);

  if (!rect) {
    return <div ref={containerRef} />;
  }

  return (
    <div ref={containerRef} className="responsive-container" style={{ width: '100%', height: '100%' }}>
      {Children.map(children, el => cloneElement(el, { container: rect, ...props }))}
    </div>
  );
};

export default ResponsiveContainer;
